import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import makePaquerypointSelector from './selectors';
import { name, reducer, actions } from './slice';
import saga from './saga';

export default function usePaquerypoints({ initialize } = {}) {
  const dispatch = useDispatch();
  useInjectReducer({ key: name, reducer });
  useInjectSaga({ key: name, saga });
  useSelector(makePaquerypointSelector(), shallowEqual);
  useEffect(() => {
    if (initialize) {
      dispatch(actions.initial());
    }
  }, [initialize, dispatch]);
}
